import { Component, Input, OnInit, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IPermissionGroup, PermissionGroup } from '../../models/permission-group.model';
import { TreeNode } from 'primeng/api';
import { TranslateModule } from '@ngx-translate/core';
import { TreeModule } from 'primeng/tree';
import { IPermission } from '../../../permissions/dtos/responses/permission.response';
import { Logger } from '../../../../../core/utilities/logging/logger';
import { ITypedLookup } from '../../../common/models/permission-marker-lookup';
import { Permission } from '../../../permissions/models/permission.model';
import { ButtonDirective } from 'primeng/button';
import { IPermissionTreeOutput } from '../../models/permission-tree-output.model';

@Component({
    selector: 'app-test-permissions-tree',
    standalone: true,
    imports: [CommonModule, TranslateModule, TreeModule],
    templateUrl: './permissions-tree.component.html'
})
export class TestPermissionsTreeComponent implements OnInit {
    @Input() input: string = '';
    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }
}
